export default __webpack_public_path__ + "media/images/react_icons/cooktop-a2b14545ae14202a93d6d4970c13f5c7.svg";